import styled, { keyframes } from 'styled-components';

const bounce = keyframes`
  0%, 80%, 100% { transform: scale(0); }
  40% { transform: scale(1); }
`;

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.8);
`;

const Dot = styled.div`
  width: 18px;
  height: 18px;
  margin: 3px;
  background-color: #ff6f61; // Use your theme color
  border-radius: 50%;
  display: inline-block;
  animation: ${bounce} 1.4s infinite ease-in-out both;
  &:nth-child(1) { animation-delay: -0.32s; }
  &:nth-child(2) { animation-delay: -0.16s; }
`;

const Loader = () => (
  <LoaderWrapper>
    <Dot />
    <Dot />
    <Dot />
  </LoaderWrapper>
);

export default Loader; 